import {
  CollectionResourceRef,
  CollectionResourceType,
} from "@/shared/domain/collections";

import { SelectedResources } from "./selectedResources";

// ── selection helpers ─────────────────────────────────────────────────────────
// Shared between CollectionsPicker.tsx and CreateForm.tsx — everything else
// that used to live here was only used by a single component and has been
// moved there as a private (unexported) helper.

export function resourceTypeOf(
  selected: SelectedResources,
): CollectionResourceType {
  return selected.type.toLowerCase() as CollectionResourceType;
}

export function resourcesOf(
  selected: SelectedResources,
): CollectionResourceRef[] {
  const resource_type = resourceTypeOf(selected);
  return Array.from(selected.items).map((id) => ({
    resource_type,
    resource_id: id,
  }));
}
